import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { ServerValidationTypes } from 'app/infrastructure/data/validation';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';

import { mapFilterMetadata } from './utils/map-filter-metadata';
import { mapFilterValidation } from './utils/map-filter-validation';
import {
  RequestFilterMetadata, ReceiveFilterMetadata, FailFilterMetadata,
  AddFilters, UpdateFilter, DeleteFilter, DeleteAllFilters, UpdateFilterValidation
} from './action-types';
import { api } from './api';
import { DefaultFiltersEndpoints } from './constants';
import { DefaultFilter, DefaultFilterValidation } from './types-store';

export const actionCreators = (component: string, endpoints: DefaultFiltersEndpoints) => ({

  addFilters: (filters: DefaultFilter[]): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      dispatch(new AddFilters(component, filters));

      if (filters.length > 0) {

        const domainIds = filters.map(filter => filter.domain.value);

        try {
          dispatch(new RequestFilterMetadata(component, domainIds));
          const filtersMetadata = await api.loadFiltersMetadata(endpoints, filters.map(filter => filter.domain.value));
          dispatch(new ReceiveFilterMetadata(component, domainIds, filtersMetadata.map(mapFilterMetadata)));
        } catch (err) {

          if (err && (err.userMessages || err.message)) {
            dispatch(new ErrorNotification(err.userMessages || err.message));
          }
          dispatch(new FailFilterMetadata(component, domainIds));
        }
      }
    },

  updateFilter: (
    domainId: number,
    filter: DefaultFilter,
    validation: DefaultFilterValidation
  ): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      dispatch(new UpdateFilter(component, domainId, filter, validation));
    },

  deleteFilter: (domainId: number): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      dispatch(new DeleteFilter(component, domainId));
    },

  deleteAllFilters: (): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      dispatch(new DeleteAllFilters(component));
    },

  updateFilterValidation: (validationMessages: ServerValidationTypes): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      dispatch(new UpdateFilterValidation(component, mapFilterValidation(validationMessages)));
    }
});
